import { isEmpty } from 'lodash';

const checkIsResetAllFilter = ({ selectedTab, filterState }) => {
  let isResetVisible = false;

  switch (selectedTab) {
    case 'host':
      const hostFilter = filterState?.host;

      isResetVisible = !isEmpty(hostFilter?.brand);

      break;

    case 'parameterByHost':
      const parameterByHostFilter = filterState?.parameterByHost;

      isResetVisible = !isEmpty(parameterByHostFilter?.brand);

      break;

    case 'session':
      const sessionFilter = filterState?.session;

      isResetVisible = !isEmpty(sessionFilter?.brand) || !isEmpty(sessionFilter?.account) || !isEmpty(sessionFilter?.platform);

      break;

    case 'accountPlatform':
      const accountPlatformFilter = filterState?.accountPlatform;

      isResetVisible = !isEmpty(accountPlatformFilter?.brand) ||  !isEmpty(accountPlatformFilter?.account) ||  !isEmpty(accountPlatformFilter?.platform) ||  !isEmpty(accountPlatformFilter?.accountType);

      break;

    default:
      break;
  }

  return isResetVisible;
};

export default checkIsResetAllFilter;
